/* file description */
import SpBusinessBtns from './sp-business-btns';

export type { SpBusinessBtnsType } from './sp-business-btns';
export default SpBusinessBtns;

